import { Box, Grid } from "@mui/material";
import React, { useState } from "react";
import MuiTabs from '../../components/MuiTabs';
import SMSWAInvoicing from "./SmsWAConfig";
import UpdateB2COrder from "../orders/UpdateB2COrder";

function SMS_WA_ConfigTabs() {
    const [active, setActive] = useState(0)

    const tabHeaders = [
        {
            label: "VAS Invoicing", key: "0"
        },
        {
            label: "COD Prepaid Config", key: "1"
        },
    ];
    return (
        <>
            {/* {isLoading && <Loader />} */}
            <Grid item xs={12} md={4}>
                <Box sx={{ width: '100%', bgcolor: '#fff', boxShadow: 1 }}>
                    <MuiTabs
                        tabs={tabHeaders}
                        active={active}
                        setActive={setActive}
                    />
                </Box>
            </Grid>
            {active === 0 && (
                <Grid item xs={12}>
                    <SMSWAInvoicing />
                </Grid>
            )}
            {active === 1 && (
                <Grid item xs={12}>
                    <UpdateB2COrder />
                </Grid>
            )}
        </>
    )
}

export default SMS_WA_ConfigTabs;